import { ApiPermissions, CefiWithdrawalsAndDepositHelpUrls, CefiWithdrawalsFeeLinks, SdkConfig } from "@cede/types";
import { CEDE_CEXS } from "../../cexs";

export const SDK_PROD_CONFIG: SdkConfig = {
  supported_cexs: [
    CEDE_CEXS.BINANCE,
    CEDE_CEXS.COINBASE,
    CEDE_CEXS.KRAKEN,
    CEDE_CEXS.GATEIO,
    CEDE_CEXS.BITFINEX,
    CEDE_CEXS.HTX,
    CEDE_CEXS.KUCOIN,
    CEDE_CEXS.OKX,
    CEDE_CEXS.BYBIT,
    CEDE_CEXS.BITGET,
    CEDE_CEXS.MEXC,
  ],
  two_keys_cexs: [CEDE_CEXS.BINANCE],
  password_cexs: [CEDE_CEXS.OKX, CEDE_CEXS.KUCOIN, CEDE_CEXS.BITGET, CEDE_CEXS.COINBASE_EXCHANGE],
  uid_cexs: [CEDE_CEXS.BITMART],
  ip_whitelist_cexs: [
    CEDE_CEXS.HTX,
    CEDE_CEXS.BINANCE,
    CEDE_CEXS.KUCOIN,
    CEDE_CEXS.GATEIO,
    CEDE_CEXS.OKX,
    CEDE_CEXS.BYBIT,
    CEDE_CEXS.BITGET,
    CEDE_CEXS.BITMART,
    CEDE_CEXS.MEXC,
  ],
  ip_whitelist_scopes_by_cex: {
    [CEDE_CEXS.BINANCE]: [ApiPermissions.WITHDRAW],
    [CEDE_CEXS.KUCOIN]: [ApiPermissions.READ, ApiPermissions.TRADE, ApiPermissions.WITHDRAW],
    [CEDE_CEXS.GATEIO]: [ApiPermissions.READ, ApiPermissions.TRADE, ApiPermissions.WITHDRAW],
    [CEDE_CEXS.OKX]: [ApiPermissions.READ, ApiPermissions.TRADE, ApiPermissions.WITHDRAW],
    [CEDE_CEXS.BYBIT]: [ApiPermissions.READ, ApiPermissions.TRADE, ApiPermissions.WITHDRAW],
    [CEDE_CEXS.BITGET]: [ApiPermissions.READ, ApiPermissions.TRADE, ApiPermissions.WITHDRAW],
    [CEDE_CEXS.BITMART]: [ApiPermissions.READ, ApiPermissions.TRADE, ApiPermissions.WITHDRAW],
    [CEDE_CEXS.HTX]: [ApiPermissions.READ, ApiPermissions.TRADE, ApiPermissions.WITHDRAW],
    [CEDE_CEXS.MEXC]: [ApiPermissions.READ, ApiPermissions.TRADE, ApiPermissions.WITHDRAW],
  },
  induced_permissions_by_cex: {
    [CEDE_CEXS.BYBIT]: {
      [ApiPermissions.WITHDRAW]: [ApiPermissions.TRADE],
    },
    [CEDE_CEXS.KUCOIN]: {
      [ApiPermissions.WITHDRAW]: [ApiPermissions.TRADE],
    },
    [CEDE_CEXS.OKX]: {
      [ApiPermissions.WITHDRAW]: [ApiPermissions.TRADE],
    },
  },
  cexs_with_sub_accounts: [
    CEDE_CEXS.BINANCE,
    CEDE_CEXS.BITGET,
    CEDE_CEXS.BYBIT,
    CEDE_CEXS.GATEIO,
    CEDE_CEXS.HTX,
    CEDE_CEXS.KUCOIN,
    CEDE_CEXS.MEXC,
    CEDE_CEXS.OKX,
  ],
  ip_whitelist_addresses: ["52.214.234.117", "52.31.181.93", "54.155.114.62"],
  address_whitelist_cexs: [
    {
      exchangeId: CEDE_CEXS.BINANCE,
      provideWhitelistedAddresses: true,
    },
    {
      exchangeId: CEDE_CEXS.OKX,
      provideWhitelistedAddresses: false,
    },
    {
      exchangeId: CEDE_CEXS.HTX,
      provideWhitelistedAddresses: false,
    },
    {
      exchangeId: CEDE_CEXS.KRAKEN,
      provideWhitelistedAddresses: true,
    },
    {
      exchangeId: CEDE_CEXS.GATEIO,
      provideWhitelistedAddresses: true,
    },
    {
      exchangeId: CEDE_CEXS.BYBIT,
      provideWhitelistedAddresses: false,
    },
    {
      exchangeId: CEDE_CEXS.BITGET,
      provideWhitelistedAddresses: false,
    },
    {
      exchangeId: CEDE_CEXS.KUCOIN,
      provideWhitelistedAddresses: false,
    },
    {
      exchangeId: CEDE_CEXS.MEXC,
      provideWhitelistedAddresses: false,
    },
  ],
  affiliation_links: {
    [CEDE_CEXS.BINANCE]: "https://accounts.binance.com/register",
    [CEDE_CEXS.BITFINEX]: "https://www.bitfinex.com/sign-up",
    [CEDE_CEXS.COINBASE]: "https://www.coinbase.com/signup",
    [CEDE_CEXS.GATEIO]: "https://www.gate.io/signup/",
    [CEDE_CEXS.HTX]: "https://www.htx.com",
    [CEDE_CEXS.KRAKEN]: "https://www.kraken.com/sign-up",
    [CEDE_CEXS.KUCOIN]: "https://www.kucoin.com/",
    [CEDE_CEXS.OKX]: "https://www.okx.com",
    [CEDE_CEXS.BYBIT]: "https://www.bybit.com/en-US/register",
    [CEDE_CEXS.BITGET]: "https://www.bitget.com/en/register",
    [CEDE_CEXS.BITSTAMP]: "https://www.bitstamp.net/ref/",
    [CEDE_CEXS.BITMART]: "https://www.bitmart.com/register/en-US",
    [CEDE_CEXS.MEXC]: "https://www.mexc.com/login",
  },
  api_management_links: {
    [CEDE_CEXS.BINANCE]: "https://www.binance.com/en/my/settings/api-management",
    [CEDE_CEXS.BITFINEX]: "https://setting.bitfinex.com/api#bitfinex",
    [CEDE_CEXS.COINBASE]: "https://portal.cdp.coinbase.com/access/api?keyType=trade",
    [CEDE_CEXS.GATEIO]: "https://www.gate.io/myaccount/api_key_manage",
    [CEDE_CEXS.HTX]: "https://www.htx.com/en-us/apikey/",
    [CEDE_CEXS.KRAKEN]: "https://www.kraken.com/u/security/api",
    [CEDE_CEXS.KUCOIN]: "https://www.kucoin.com/api",
    [CEDE_CEXS.OKX]: "https://www.okx.com/account/my-api",
    [CEDE_CEXS.BYBIT]: "https://www.bybit.com/en/login?redirect_url=https://www.bybit.com/app/user/api-management",
    [CEDE_CEXS.BITGET]: "https://www.bitget.com/account/newapi",
    [CEDE_CEXS.BITSTAMP]: "https://www.bitstamp.net/settings/access-control/api/",
    [CEDE_CEXS.BITMART]: "https://www.bitmart.com/api-config/en-US",
    [CEDE_CEXS.MEXC]: "https://www.mexc.com/user/openapi",
  },
  address_management_urls: {
    [CEDE_CEXS.BINANCE]: "https://www.binance.com/en/my/security/address-management",
    [CEDE_CEXS.OKX]: "https://www.okx.com/balance/withdrawal",
    [CEDE_CEXS.BITGET]: "https://www.bitget.com/asset/address",
    [CEDE_CEXS.BYBIT]: "https://www.bybit.com/en/login?redirect_url=https://www.bybit.com/user/assets/money-address",
    [CEDE_CEXS.KRAKEN]: "https://www.kraken.com/u/funding/withdraw?asset=",
    [CEDE_CEXS.HTX]: "https://www.htx.com/en-us/finance/address/",
    [CEDE_CEXS.GATEIO]: "https://www.gate.io/myaccount/withdraw_address",
    [CEDE_CEXS.KUCOIN]: "https://www.kucoin.com/withdraw-addr-manage",
    [CEDE_CEXS.MEXC]: "https://www.mexc.com/user/withdraw-address",
  },
  networks_under_maintenance: {
    [CEDE_CEXS.KRAKEN]: "lightning",
  },
  send: {
    [CEDE_CEXS.BINANCE]: true,
    [CEDE_CEXS.HTX]: true,
    [CEDE_CEXS.BITFINEX]: true,
    [CEDE_CEXS.GATEIO]: true,
    [CEDE_CEXS.KUCOIN]: true,
    [CEDE_CEXS.KRAKEN]: true,
    [CEDE_CEXS.BITGET]: true,
    [CEDE_CEXS.COINBASE]: true,
    [CEDE_CEXS.BYBIT]: true,
    [CEDE_CEXS.OKX]: true,
    [CEDE_CEXS.MEXC]: true,
    [CEDE_CEXS.BITSTAMP]: true,
  },
  trade: {
    [CEDE_CEXS.BINANCE]: true,
    [CEDE_CEXS.HTX]: true,
    [CEDE_CEXS.BITFINEX]: true,
    [CEDE_CEXS.GATEIO]: true,
    [CEDE_CEXS.KUCOIN]: true,
    [CEDE_CEXS.KRAKEN]: true,
    [CEDE_CEXS.BITGET]: true,
    [CEDE_CEXS.COINBASE]: true,
    [CEDE_CEXS.BYBIT]: true,
    [CEDE_CEXS.OKX]: true,
    [CEDE_CEXS.MEXC]: true,
    [CEDE_CEXS.BITSTAMP]: true,
    [CEDE_CEXS.BITMART]: true,
    [CEDE_CEXS.CRYPTOCOM]: true,
    [CEDE_CEXS.BITHUMB]: true,
  },
  limit_trade: {
    [CEDE_CEXS.BINANCE]: true,
    [CEDE_CEXS.BITGET]: true,
    [CEDE_CEXS.CRYPTOCOM]: true,
    [CEDE_CEXS.GATEIO]: true,
    [CEDE_CEXS.KUCOIN]: true,
    [CEDE_CEXS.MEXC]: true,
  },
  receive: {
    [CEDE_CEXS.BINANCE]: true,
    [CEDE_CEXS.HTX]: true,
    [CEDE_CEXS.BITFINEX]: true,
    [CEDE_CEXS.GATEIO]: true,
    [CEDE_CEXS.KUCOIN]: true,
    [CEDE_CEXS.KRAKEN]: true,
    [CEDE_CEXS.BITGET]: true,
    [CEDE_CEXS.COINBASE]: true,
    [CEDE_CEXS.BYBIT]: true,
    [CEDE_CEXS.OKX]: true,
    [CEDE_CEXS.MEXC]: true,
    [CEDE_CEXS.BITSTAMP]: true,
  },
  trade_and_send: {
    [CEDE_CEXS.BINANCE]: true,
    [CEDE_CEXS.BITFINEX]: true,
    [CEDE_CEXS.BITGET]: true,
    [CEDE_CEXS.BITHUMB]: true,
    [CEDE_CEXS.BYBIT]: true,
    [CEDE_CEXS.COINBASE]: true,
    [CEDE_CEXS.CRYPTOCOM]: false,
    [CEDE_CEXS.GATEIO]: true,
    [CEDE_CEXS.HTX]: true,
    [CEDE_CEXS.KRAKEN]: true,
    [CEDE_CEXS.KUCOIN]: true,
    [CEDE_CEXS.MEXC]: true,
    [CEDE_CEXS.OKX]: true,
  },
  trade_square: {
    [CEDE_CEXS.BINANCE]: true,
    [CEDE_CEXS.BITGET]: true,
    [CEDE_CEXS.BITHUMB]: true,
    [CEDE_CEXS.BYBIT]: true,
    [CEDE_CEXS.CRYPTOCOM]: true,
    [CEDE_CEXS.GATEIO]: true,
    [CEDE_CEXS.KRAKEN]: true,
    [CEDE_CEXS.KUCOIN]: true,
    [CEDE_CEXS.MEXC]: true,
  },
  send_under_maintenance: {
    [CEDE_CEXS.COINBASE]: true,
  },
  trade_under_maintenance: {},
  trade_and_send_under_maintenance: {},
  receive_under_maintenance: {},
  send_minimum_help_urls: {
    [CEDE_CEXS.KRAKEN]: CefiWithdrawalsFeeLinks.KRAKEN,
  },
  receive_minimum_help_urls: {
    [CEDE_CEXS.BINANCE]: CefiWithdrawalsAndDepositHelpUrls.BINANCE,
    [CEDE_CEXS.KRAKEN]: CefiWithdrawalsAndDepositHelpUrls.KRAKEN,
    [CEDE_CEXS.GATEIO]: CefiWithdrawalsAndDepositHelpUrls.GATEIO,
    [CEDE_CEXS.BYBIT]: CefiWithdrawalsAndDepositHelpUrls.BYBIT,
  },
  send_cexs_appending_fees_to_amount: [CEDE_CEXS.HTX, CEDE_CEXS.OKX],
  enable_sentry: true,
  oauth_login_cexs: [CEDE_CEXS.COINBASE, CEDE_CEXS.OKX],
  pkce_flow_cexs: [CEDE_CEXS.OKX, CEDE_CEXS.BYBIT], // bybit isn't really pkce compliant, they just don't ask for the client secret
  fast_api_cexs: [],
  hybrid_cexs: {
    [CEDE_CEXS.OKX]: {
      oauth: [ApiPermissions.READ, ApiPermissions.TRADE],
      api_keys: [ApiPermissions.READ, ApiPermissions.TRADE, ApiPermissions.WITHDRAW],
    },
  },
  require_email_confirmation: [CEDE_CEXS.BITFINEX],
  enable_exchange_local_availibility: true,
  support_verify_kyc: {
    [CEDE_CEXS.KUCOIN]: true,
    [CEDE_CEXS.BYBIT]: true,
    [CEDE_CEXS.GATEIO]: true,
    [CEDE_CEXS.BITGET]: true,
    [CEDE_CEXS.MEXC]: true,
    [CEDE_CEXS.HTX]: true,
    [CEDE_CEXS.OKX]: true,
  },
  internal_transfer: {
    [CEDE_CEXS.BINANCE]: true,
    [CEDE_CEXS.KUCOIN]: true,
    [CEDE_CEXS.OKX]: true,
    [CEDE_CEXS.BYBIT]: true,
    [CEDE_CEXS.BITFINEX]: true,
    [CEDE_CEXS.BITGET]: true,
    [CEDE_CEXS.BITMART]: true,
    [CEDE_CEXS.GATEIO]: true,
    [CEDE_CEXS.HTX]: true,
    [CEDE_CEXS.MEXC]: true,
  },
};
